import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const fileExplorerStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  clearButton: {
    borderColor: theme.palette.error.light,
    color: theme.palette.error.light,
    '&:hover': {
      borderColor: theme.palette.error.main,
    },
  },
  clearAllButton: {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    '&:hover': {
      borderColor: theme.palette.error.dark,
    },
  },
  headerText: {
    color: '#fff',
  },
  headerIcon: {
    color: '#fff',
    backgroundColor: '#9fa8da',
    borderRadius: '50%',
  },
}));

export const UploadBar = styled.div`
  position: fixed;
  display: flex;
  width: 600px;
  max-width: 100%;
  height: 2em;
  bottom: 0.5em;
  right: 0.5em;
  background-color: #3f51b5;
  justify-content: space-between;
  align-items: center;
  padding: 0.25em 1em;
  /* border-radius: 0.25em; */
  padding: 20px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
`;

export const UploadBarTop = styled.div`
  display: flex;
  /* width: 24em; */
  padding: 0.25em 1em;
  height: 2em;
  background-color: #3f51b5;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
`;

export const UploadBarFull = styled.div`
  position: fixed;
  display: flex;
  width: 600px;
  max-width: 100%;
  bottom: 0.5em;
  right: 0.5em;
  background-color: #fff;
  justify-content: center;
  flex-direction: column;
  /* border: 1px solid #b8b6b6; */
  border-radius: 6px;
  z-index: 1301;
`;

export const ButtonHeader = styled.header`
  display: flex;
  justify-content: space-between;
  background-color: #fafafa;
  padding: 0.5em 0.2em;
  border-right: 1px solid #b8b6b6;
  border-left: 1px solid #b8b6b6;
`;

export const UploadRow = styled.div`
  margin: 0em 1em;
  padding: 2em 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3em;
  border-bottom: 1px solid #8080802e;
`;

export const UploadRowAction = styled.div`
  /* padding: 0.25em 1em; */
  display: flex;
  align-items: center;
  height: 3em;
`;

export const UploadFileView = styled.div`
  display: flex;
  align-items: center;
`;

export const UploadList = styled.div`
  max-height: 80vh;
  overflow: auto;
  border: 1px solid #b8b6b6;
  border-top: none;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
`;

export const fileExplorerMainStyles = makeStyles(theme => ({
  root: {
    paddingBottom: '3rem',
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  eachSubjet: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    border: '1px solid #c7c3c3',
    borderRadius: '4px',
    height: '5.5rem',
  },
  borderBottom: {
    borderBottom: '2px solid #efefef',
    margin: '1.5rem 0',
    paddingBottom: '1.5rem',
  },
  borderLess: {
    borderBottom: 'none',
  },
  alertMessage: {
    position: 'fixed',
    bottom: '50px',
    width: '80%',
  },
  pointer: {
    cursor: 'pointer',
  },
  button: {
    height: '100%',
  },
  customSnackBar: {
    position: 'fixed',
    bottom: '55px',
    zIndex: '1',
    width: 'calc(100% - 256px - 48px)',
    [theme.breakpoints.down('md')]: {
      width: 'calc(100% - 48px)',
    },
  },
}));

export const DropBoxOut = styled.div`
  padding: 4em 4em;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.5px dashed #80808033;
  background-color: #fff;
`;

export const fileUploadStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));
